module.exports = __webpack_public_path__ + "img/vector_man_laptop.5be5ec83.svg";